import { CALL_API } from '../middleware/api';

export const LOADED_USERS_SUCCESS = Symbol('LOADED_USERS_SUCCESS');
export const FETCHED_EVENT_INFO = Symbol('FETCHED_EVENT_INFO');
export const FETCHED_EVENT_INFO_SUCCESS = Symbol('FETCHED_EVENT_INFO_SUCCESS');
export const FETCHED_EVENT_INFO_FAILURE = Symbol('FETCHED_EVENT_INFO_FAILURE');
export const FETCHED_EVENT_INFO_DETAILS_SUCCESS = Symbol('FETCHED_EVENT_INFO_DETAILS_SUCCESS');
export const FETCHED_EVENT_INFO_DETAILS_FAILURE = Symbol('FETCHED_EVENT_INFO_DETAILS_FAILURE');
export const FETCHED_COMPLETED_EVENTS = Symbol('FETCHED_COMPLETED_EVENTS');
export const FETCHED_COMPLETED_EVENTS_SUCCESS = Symbol('FETCHED_COMPLETED_EVENTS_SUCCESS');
export const FETCHED_COMPLETED_EVENTS_FAILURE = Symbol('FETCHED_COMPLETED_EVENTS_FAILURE');
export const CREATE_EVENT_FROM_FIREFLY = Symbol('CREATE_EVENT_FROM_FIREFLY');
export const CREATE_EVENT_FROM_FIREFLY_SUCCESS = Symbol('CREATE_EVENT_FROM_FIREFLY_SUCCESS');
export const CREATE_EVENT_FROM_FIREFLY_ERROR = Symbol('CREATE_EVENT_FROM_FIREFLY_ERROR');
export const DELETE_MEETING_SUCCESS = Symbol('DELETE_MEETING_SUCCESS');
export const DELETE_MEETING_FAILURE = Symbol('DELETE_MEETING_FAILURE');
export const FETCH_MEETING = Symbol('FETCH_MEETING');
export const FETCH_MEETING_SUCCESS = Symbol('FETCH_MEETING_SUCCESS');
export const FETCH_MEETING_FAILURE = Symbol('FETCH_MEETING_FAILURE');
export const UPDATE_FIELD = Symbol('UPDATE_FIELD');
export const RESET_MEETING_POPUP_FORM = Symbol('RESET_MEETING_POPUP_FORM');
export const CLOSE_VALIDATION_ERROR = Symbol('CLOSE_VALIDATION_ERROR');

export function findUsers({ filter, page = 1, afterSuccess }) {
  return {
    filter,
    [CALL_API]: {
      method: 'get',
      path: '/api/v1/browse/users',
      unifier: params => `${params.path}`,
      maxCount: 2,
      query: {
        like: filter,
        page,
      },
      successType: LOADED_USERS_SUCCESS,
      afterSuccess,
    },
  };
}

export const fetchTargetEventInfo = ({ page = 1, limit = 30, filter, afterSuccess }) => ({
  page,
  [CALL_API]: {
    method: 'get',
    path: `/api/v1/browse/simple/companies?page=${page}&limit=${limit}&keywords=${filter}&searchByName=1&onlyTargets=1`,
    unifier: params => `${params.path}`,
    maxCount: 2,
    startType: FETCHED_EVENT_INFO,
    successType: FETCHED_EVENT_INFO_SUCCESS,
    errorType: FETCHED_EVENT_INFO_FAILURE,
    afterSuccess,
  },
});

export const fetchBuyerEventInfo = ({ page = 1, limit = 30, filter, afterSuccess }) => ({
  page,
  [CALL_API]: {
    method: 'get',
    path: `/api/v1/browse/simple/companies?page=${page}&limit=${limit}&keywords=${filter}&searchByName=1&onlyBuyers=1`,
    unifier: params => `${params.path}`,
    maxCount: 2,
    startType: FETCHED_EVENT_INFO,
    successType: FETCHED_EVENT_INFO_SUCCESS,
    errorType: FETCHED_EVENT_INFO_FAILURE,
    afterSuccess,
  },
});

export function fetchEventInfoById({ id, afterSuccess }) {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/browse/simple/companies/${id}`,
      successType: FETCHED_EVENT_INFO_DETAILS_SUCCESS,
      errorType: FETCHED_EVENT_INFO_DETAILS_FAILURE,
      afterSuccess,
    },
  };
}

export function fetchCompetedEvents({ companyId, companyType, afterSuccess }) {
  if (!companyId) {
    return;
  }

  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/fireflies/completed_events?company_id=${companyId}&company_type=${companyType}`,
      startType: FETCHED_COMPLETED_EVENTS,
      successType: FETCHED_COMPLETED_EVENTS_SUCCESS,
      errorType: FETCHED_COMPLETED_EVENTS_FAILURE,
      afterSuccess,
    },
  };
}

export function createMeeting({ body, afterSuccess, afterError }) {
  return {
    body,
    [CALL_API]: {
      method: 'post',
      path: '/api/v1/fireflies/events',
      body,
      startType: CREATE_EVENT_FROM_FIREFLY,
      successType: CREATE_EVENT_FROM_FIREFLY_SUCCESS,
      errorType: CREATE_EVENT_FROM_FIREFLY_ERROR,
      afterSuccess,
      afterError,
      skipGlobalErrorHandler: true,
    },
  };
}

export function fetchMeetingById({ id, user, afterSuccess, afterError }) {
  return {
    user,
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/fireflies/meetings/${id}`,
      startType: FETCH_MEETING,
      successType: FETCH_MEETING_SUCCESS,
      errorType: FETCH_MEETING_FAILURE,
      afterSuccess,
      afterError,
    },
  };
}

export function deleteMeeting({ id, afterSuccess, afterError }) {
  return {
    [CALL_API]: {
      method: 'delete',
      path: `/api/v1/fireflies/meetings/${id}`,
      successType: DELETE_MEETING_SUCCESS,
      errorType: DELETE_MEETING_FAILURE,
      afterSuccess,
      afterError,
    },
  };
}

export function changeField({ name, value }) {
  return {
    type: UPDATE_FIELD,
    name,
    value,
  };
}

export function resetForm() {
  return {
    type: RESET_MEETING_POPUP_FORM,
  };
}
